import {HomeEvent} from '@apuestes/types'
import {initialHomeEventState} from '../../../../_metronic/helpers'
import {createSlice} from '@reduxjs/toolkit'
import {apuestesAPI} from '../../services/apuestesAPI'

const homeEventSlice = createSlice({
  name: 'homeEvent',
  initialState: {
    meta: {fetch: false, id: -1},
    value: initialHomeEventState,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addMatcher(apuestesAPI.endpoints.getModelById.matchFulfilled, (state, action) => {
        if (action.meta.arg.originalArgs.model === 'home/events/bo') {
          state.value = action.payload as unknown as HomeEvent
        }
      })
      .addMatcher(apuestesAPI.endpoints.updateModel.matchFulfilled, (state, action) => {
        if (action.meta.arg.originalArgs.model === 'home/events') {
          state.value = action.payload as unknown as HomeEvent
        }
      })
  },
})

export default homeEventSlice.reducer
